<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.5547 9.83205C9.8329 9.64658 10 9.33435 10 9V5C10 3.34315 8.65685 2 7 2H3C2.44772 2 2 2.44772 2 3C2 12.9411 11.0589 22 21 22C21.5523 22 22 21.5523 22 21V17C22 15.3431 20.6569 14 19 14H15C14.6656 14 14.3534 14.1671 14.1679 14.4453L12.2626 17.3033C10.1874 15.9615 8.36925 14.1892 6.97074 12.149L6.69668 11.7374L9.5547 9.83205ZM15.5352 16H19C19.5523 16 20 16.4477 20 17V19.9653C18.0628 19.8313 16.1721 19.3132 14.4087 18.4916L14.0041 18.2966L15.5352 16ZM14 6C16.2091 6 18 7.79086 18 10C18 10.5523 17.5523 11 17 11C16.4872 11 16.0645 10.614 16.0067 10.1166L15.9945 9.85074C15.9182 8.81588 15.0544 8 14 8C13.4477 8 13 7.55228 13 7C13 6.44772 13.4477 6 14 6ZM14 2C18.4183 2 22 5.58172 22 10C22 10.5523 21.5523 11 21 11C20.4477 11 20 10.5523 20 10C20 6.68629 17.3137 4 14 4C13.4477 4 13 3.55228 13 3C13 2.44772 13.4477 2 14 2ZM7 4C7.55228 4 8 4.44772 8 5V8.46482L5.70338 9.9959C4.76882 8.11845 4.17903 6.08626 4.03467 4H7Z"
    fill="currentColor"
  />
</svg>
